import { Component, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';




@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {


  images = [
    { img: './assets/PF/Tr1.png', title: "Flight", description: 'Transportation', text: "Transportation We Have For You." },
    { img: './assets/PF/Attr4.png', title: "Elephant Nature Park", description: 'Attraction', text: "Some Attractions We Have For You." },
    { img: './assets/PF/Tr6.png', title: "Bus", description: 'Transportation', text: "Transportation We Have For You." },
    { img: './assets/PF/Attr7.png', title: "Lion Park", description: 'Attraction', text: "Some Attractions We Have For You." },
    { img: './assets/PF/Tr4.png', title: "Train", description: 'Transportation', text: "Transportation We Have For You." },
    { img: './assets/PF/Attr1.png', title: "Kwa-Zulu", description: 'Attraction', text: "Some Attractions We Have For You." },

  ];

  team = [
    { img: './assets/Team/Vee.png', name: 'Vuyelwa Mnqosini', about: "Promotion and marketing of the business through various channels. ", about2: "Presentation of business services to potential clients.", about3: "Management of business administration.", about4: "" },
    { img: './assets/Team/Bafana.png', name: 'Bafana Maseko', about: "Meeting profit and sales targets. ", about2: "Budget management.", about3: "Maintenance of statistical financial records.", about4: "Providing clients with advice on travel and tours" },
    { img: './assets/Team/Max.png', name: 'Mackson Chirwa', about: "Dealing with customer complaints or queries. ", about2: "Providing clients with advice on passports and visas.", about3: "Preparation of promotional material.", about4: "Photography and videography" },
  ];

  onAbout: boolean = false;
  onService: boolean = false;
  onPort: boolean = false;
  onTeam: boolean = false;
  onHome: boolean = false;

  @HostListener("window:scroll", []) onWindowScroll() {
    this.scrollFunction();
  }
  // When the user scrolls down 20px from the top of the document, show the button
  scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("myBtn")!.style.display = "block";

      document.getElementById("responsive")!.style.color = "black";

      document.getElementById("myTopnav")!.style.backgroundColor = "#ffffffda";
    } else {
      document.getElementById("myBtn")!.style.display = "none";

      document.getElementById("myTopnav")!.style.backgroundColor = "transparent";
    
      document.getElementById("responsive")!.style.color = "black";
      document.getElementById("responsive")!.style.backgroundColor = "transparent";
    }
  }

  // When the user clicks on the button, scroll to Service
  toService() {
    this.onService = true;
    this.onAbout = false;
    this.onPort = false;
    this.onTeam = false;
    this.onHome = false;
    document.getElementById('toService')?.scrollIntoView({ behavior: 'smooth' })
    if (this.onService == true) {
      document.getElementById("service")!.style.color = "rgb(255, 146, 5)";//rgb(59, 58, 58)
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("about")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("port")!.style.color = "rgb(59, 58, 58)";
     // document.getElementById("team")!.style.color = "rgb(59, 58, 58)";
    }

  }


  // When the user clicks on the button, scroll to About
  toAbout() {
    this.onService = false;
    this.onAbout = true;
    this.onPort = false;
    this.onTeam = false;
    this.onHome = false;;

    document.getElementById('toAbout')?.scrollIntoView({ behavior: 'smooth' });

    if (this.onAbout == true) {
      document.getElementById("service")!.style.color = "rgb(59, 58, 58)";//rgb(59, 58, 58)
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("about")!.style.color = "rgb(255, 146, 5)";
      document.getElementById("port")!.style.color = "rgb(59, 58, 58)";
      //document.getElementById("team")!.style.color = "rgb(59, 58, 58)";
    }


  }

  // When the user clicks on the button, scroll to About
  toPort() {
    document.getElementById('toPort')?.scrollIntoView({ behavior: 'smooth' })
    this.onService = false;
    this.onAbout = false;
    this.onPort = true;
    this.onTeam = false;
    this.onHome = false;

    if (this.onPort == true) {
      document.getElementById("service")!.style.color = "rgb(59, 58, 58)";//rgb(59, 58, 58)
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("about")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("port")!.style.color = "rgb(255, 146, 5)";
     // document.getElementById("team")!.style.color = "rgb(59, 58, 58)";
    }
  }


  // When the user clicks on the button, scroll to About
  toTeam() {
    this.onService = false;
    this.onAbout = false;
    this.onPort = false;
    this.onTeam = true;
    this.onHome = false;
    document.getElementById('toTeam')?.scrollIntoView({ behavior: 'smooth' })

    if (this.onTeam == true) {
      document.getElementById("service")!.style.color = "rgb(59, 58, 58)";//rgb(59, 58, 58)
      document.getElementById("home")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("about")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("port")!.style.color = "rgb(59, 58, 58)";
     // document.getElementById("team")!.style.color = "rgb(255, 146, 5)";
    }
  }

  // When the user clicks on the button, scroll to About
  toContact() {
    document.getElementById('toContact')?.scrollIntoView({ behavior: 'smooth' })

  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction() {
    this.onService = false;
    this.onAbout = false;
    this.onPort = false;
    this.onTeam = false;
    this.onHome = true;
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' })

    if (this.onHome == true) {
      document.getElementById("service")!.style.color = "rgb(59, 58, 58)";//rgb(59, 58, 58)
      document.getElementById("home")!.style.color = "rgb(255, 146, 5)";
      document.getElementById("about")!.style.color = "rgb(59, 58, 58)";
      document.getElementById("port")!.style.color = "rgb(59, 58, 58)";
     // document.getElementById("team")!.style.color = "rgb(59, 58, 58)";
    }
  }
  constructor() {
    localStorage.clear();
  }
  
  ngOnInit(): void {

  }

  see: boolean = false;
  see2: boolean = true;

  seeMore() {
    this.see = true;
  }

  seeLess() {
    this.see = false;
  }

  seeMore2() {
    this.see2 = false;
  }

  seeLess2() {
    this.see2 = true;
  }


  myFunction() {
    var x = document.getElementById("myTopnav")!;
    if (x.className === "topnav") {
      x.className += " responsive";
    } else {
      x.className = "topnav";
    }
  }
  //Close Nav
  closeNav() {
    var x = document.getElementById("myTopnav")!;
    if (x.className === "topnav") {
      
    } else {
      x.className = "topnav";
      document.getElementById("nav")!.style.color = "white";

    }
  }

}
